import React from 'react';
import clsx from 'clsx';
import {
	AvatarGroup,
	AvatarItem,
} from '@/components/common/avatar/avatarGroup';
import { Typography, TypographyType } from '../typography';

interface Props {
	typographyType?: TypographyType;
	typographyClassName?: string;
	avatarItems: AvatarItem[];
	text?: React.ReactNode;
	className?: string;
	size?: 'sm' | 'md' | 'base' | 'lg';
}

export const AvatarSocialProof: React.FC<Props> = ({
	avatarItems,
	text,
	className,
	typographyType = 'regular-12',
	typographyClassName = '!text-sm lg:!text-xs',
	size = 'lg',
}) => {
	return (
		<div className={clsx('flex items-center gap-2 lg:gap-3', className)}>
			<AvatarGroup options={avatarItems} size={size} />
			<Typography type={typographyType} className={typographyClassName}>
				{text ?? (
					<>
						Join <span className="font-semibold">+5,000</span> other Claim Magic
						claimants who are getting what they deserve
					</>
				)}
			</Typography>
		</div>
	);
};
